"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Power
 *
 * Generate all the nth powers - e.g. all squares, all cubes etc
 */
// Public API
exports.default = function (n) {
  return (0, immutable_1.Seq)(generator(n));
};
// Generator
function generator(n) {
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var x;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          x = Math.pow(Math.pow(current, 1 / n) + 1, n);
          return _context.delegateYield(generator(n, x), "t0", 4);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=nthpower.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/nthpower.js
// module id = 278
// module chunks = 0